module.exports = __webpack_public_path__ + "static/popcornready-0749e49b2e2454ebddd4aef1587fff6a.svg";